import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const StavPujcovny = {
	name: NAME,
	apiProvider,
	router,
};
